export const AUTOMATION_TYPES = [
    {
        type: 'bcu_credit',
        label: 'Consulta BCU',
        description: 'Consulta la Central de Riesgos Crediticios del Banco Central del Uruguay',
        inputs: [
            { key: 'documentNumber', label: 'Nro. de documento (cedula)', required: true },
            { key: 'periodo', label: 'Periodo (AAAAMM)', required: false, defaultDescription: 'Mes actual' },
        ],
    },
];
